import * as types from '../types';
import User from '@/models/User';
import Vue from 'vue';
import config from '@/config';
import UserApi from '@/api/user';

// Initial state
// -------------
const state = {
    userConnected:  false,
};

// Getters
// -------
const getters = {
    userConnected:  state => state.userConnected,
};

// Mutations
// ---------
const mutations = {
    /**
     * User login
     *
     * @author Fabien Bellanger
     * @param {Object}    state
     */
    [types.M_USER_LOGIN](state)
    {
        // TODO:
    },
};

// Actions
// -------
const actions = {
    /**
     * User login
     *
     * @author Fabien Bellanger
     * @param {Object}    store
     * @param {Object}    data
     */
    [types.A_USER_LOGIN](store, data)
    {
        // TODO:
        UserApi.postLogin(data)
            .then((response) =>
            {
                console.log(response);
            })
            .catch((error) =>
            {
                console.error(error);
            });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
